var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("MFStand QA Home")]),_c('a',{attrs:{"href":'//sentera.atlassian.net/wiki/spaces/SPO/pages/3047489599/Stand+QA+tool+Keybinds',"target":"_blank"}},[_vm._v(" Useful Keybinds ")])])}
var staticRenderFns = []

export { render, staticRenderFns }